import { useState, type PropsWithChildren } from "react";
import {
  PrimaryControlsStripTitleContext,
  createPrimaryControlsStripTitleRegistry,
} from "#primary-controls-strip-title-context";

/** Wraps the subtree containing both `PrimaryControlsStripTitleHost` and `PrimaryControlsStripTitle` callsites. */
export function PrimaryControlsStripTitleProvider({ children }: PropsWithChildren) {
  const [registry] = useState(() => createPrimaryControlsStripTitleRegistry());
  return (
    <PrimaryControlsStripTitleContext.Provider value={registry}>
      {children}
    </PrimaryControlsStripTitleContext.Provider>
  );
}
